<div class="cont-carousel-100" [ngClass]="{'width-login': bannerLogin, 'banner-new-home': bannerNewHome}">
  <div class="cont-carousel-virtual" [ngClass]="{'no-top-vzla': !countryConfig.bannersComponent.bannerAvailable}" [class]="customClasses" *ngIf="isBrowser && dataLoaded" [class.cont-carousel-virtual--category]="isCategory">
    <virtual-scroller #scroll
                      [items]="banners"
                      class="virutal-scroll"
                      [horizontal]="true"
                      [ssrChildHeight]="370"
                      [ssrChildWidth]="800"
                      [ssrViewportHeight]="1080"
                      [ssrViewportWidth]="1920"
                      (vsEnd)="eventScroll($event)"
                      [enableUnequalChildrenSizes]="true"
                      >
      <div class="cont-items" *ngFor="let banner of scroll.viewPortItems">
        <app-banner-element
          [banner]="banner"
          [lazyLoaded]="true"
          [customClass] = "customClasses"
        >
      </app-banner-element>
      </div>
    </virtual-scroller>
    <div class="arrow" (click)="next()" [class.arrow-circles]="customClasses === 'circle'" [class.disabled]="arrows.right.disabled" *ngIf="arrows.right.show">
      <app-icons [type]="'arrow-simple'" [custom]="'md'"></app-icons>
    </div>
    <div class="arrow arrow-back" (click)="back()" [class.arrow-circles]="customClasses === 'circle'" [class.disabled]="arrows.left.disabled" *ngIf="arrows.left.show">
      <app-icons [type]="'arrow-simple'" [custom]="'md left'"></app-icons>
    </div>
  </div>

</div>


<div *ngIf="!isBrowser" class="cont-carousel-virtual" [class.ssr]="!isBrowser">
  <img class="placeholder-image" [src]="placeholderImg" alt="Placeholder Banner">
</div>

<div *ngIf="false" class="skeleton-banner">
</div>
